import React from 'react';
import HappyKid from './assets/HappyKid.jpg'


function Class() {
  return (
    <div>
      <img src={HappyKid} alt="" className='object-cover'/>
    </div>
  );
}

export default Class;
